import { CommonModule } from '@angular/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { PhoneCountryCodeDropdownInputComponent } from '../../../../form-components/phone-country-code/country-code-dropdown-input/phone-country-code-dropdown-input.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-review-phone-country-code-dropdown-input',
  standalone: true,
  imports: [CommonModule, NgbDropdownModule],
  templateUrl: './review-phone-country-code-dropdown-input.component.html',
  styleUrls: ['./review-phone-country-code-dropdown-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ReviewPhoneCountryCodeDropdownInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewPhoneCountryCodeDropdownInputComponent extends PhoneCountryCodeDropdownInputComponent {}
